// extracted by mini-css-extract-plugin
export default {"tabs":"spaceCatalog_tabs__JIWJz","tab":"spaceCatalog_tab__Yj1xL"};